// extracted by mini-css-extract-plugin
export default {"pathCount":"PathControls_pathCount__AxC2z"};